import { SOCIAL_POST_LIMITS } from '@exfluential/social-posts';

export {
  SOCIAL_POST_LIMITS,
  type SocialPostLimits as SocialPostPlatformLimits,
  type SocialPostPlatform,
} from '@exfluential/social-posts';

// Used outside social-post flows (e.g. hub logos) where a platform isn't known.
// Picks the strictest image limit so any image uploaded here can be reused for
// any platform without a follow-up size warning.
export const SOCIAL_POST_IMAGE_SIZE_LIMIT =
  SOCIAL_POST_LIMITS.instagram.imageMaxBytes;
export const SOCIAL_POST_VIDEO_SIZE_LIMIT =
  SOCIAL_POST_LIMITS.instagram.videoMaxBytes;

export enum SocialPostStatus {
  POSTED = 'posted',
  SCHEDULED = 'scheduled',
  FAILED = 'failed',
  RESCHEDULE_REQUIRED = 'reschedule-required',
}
